import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { user, ready } = useAuth();
  if (!ready) {
    return (
      <div className="min-h-[70vh] flex items-center justify-center pt-24" data-testid="auth-loading">
        <span className="text-sm text-muted-foreground uppercase tracking-widest">Loading…</span>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

export const AdminRoute = ({ children }) => {
  const { user, ready } = useAuth();
  if (!ready) {
    return (
      <div className="min-h-[70vh] flex items-center justify-center pt-24" data-testid="auth-loading">
        <span className="text-sm text-muted-foreground uppercase tracking-widest">Loading…</span>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "admin") return <Navigate to="/account" replace />;
  return children;
};
